/** Verifica se o valor informado é um Payload de Request */
const isRequestPayload = (value: unknown): value is RequestPayload => value instanceof RequestPayload;

/**
 * Payload de Request Abstrato que serve como base para os demais Payloads de Request da Aplicação
 */
export abstract class RequestPayload {
    /** Propriedade do Payload de Request com erro */
    private _propError: string;
    /** Mensagem de erro do Payload de Request */
    private _messageError: string;

    /** Seta qual a propriedade do Payload de Request está com erro */
    protected setPropError(propError: string) {
        this._propError = propError;
    }

    /** Obtem qual a propriedade do Payload de Request está com erro */
    get propError(): string {
        return this._propError;
    }

    /** Seta a mensagem de erro do Value Object */
    protected setMessageError(messageError: string) {
        this._messageError = messageError;
    }

    /** Obtem a mensagem de erro do Value Object */
    get messageError(): string {
        return this._messageError;
    }

    /** Verifica se o Payload de Request está inválido */
    public isValid(): boolean {
        this.setPropError('unknown');
        this.setMessageError('unknown');
        return false;
    }
}
